
import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';

interface MessageInputProps {
  newMessage: string;
  setNewMessage: (value: string) => void;
  handleSendMessage: (e: React.FormEvent) => void;
  isSending: boolean;
  user: boolean;
  username: string;
  setIsUsernameSaved: (value: boolean) => void;
}

const MessageInput: React.FC<MessageInputProps> = ({
  newMessage,
  setNewMessage,
  handleSendMessage,
  isSending,
  user,
  username,
  setIsUsernameSaved
}) => {
  return (
    <form onSubmit={handleSendMessage} className="space-y-2">
      {!user && (
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center">
            <span className="text-sm mr-2">Chatting as:</span>
            <span className="font-medium">{username}</span>
          </div>
          <Button 
            type="button" 
            variant="outline" 
            size="sm"
            onClick={() => setIsUsernameSaved(false)}
          >
            Change Name
          </Button>
        </div>
      )}
      
      <div className="flex">
        <Textarea
          placeholder="Type your message..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          required
          className="flex-1 resize-none min-h-[60px] max-h-[120px]"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              if (newMessage.trim() && (user || username.trim())) {
                handleSendMessage(e);
              }
            }
          }}
        />
        <Button 
          type="submit" 
          className="ml-2 self-end h-10"
          disabled={isSending}
        >
          <Send className="h-4 w-4" />
        </Button>
      </div>
    </form>
  );
};

export default MessageInput;
